/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import Link from 'next/link';

import { Popup } from '../Popup';
import * as S from './Articles.style';
import * as T from './Articles.types';

export const Articles: React.FC<T.IntegrationsContentCollection> = ({
  banners,
  categories,
  items,
}) => {
  const [categorySelected, setCategorySelected] = React.useState('');
  const [appSelected, setAppSelected] = React.useState<T.App>();
  const handleSetCategorySelected = function (category: string) {
    setCategorySelected(category);
    setAppSelected(undefined);
  };

  return (
    <S.Container>
      <S.Integrations>
        <S.ListCategories>
          <S.Li
            className={categorySelected === '' ? 'active' : ''}
            onClick={() => setCategorySelected('')}
          >
            Todos
          </S.Li>
          {categories.map((item) => {
            return (
              <S.Li
                key={item}
                className={item === categorySelected ? 'active' : ''}
                onClick={() => setCategorySelected(item)}
              >
                {item}
              </S.Li>
            );
          })}
        </S.ListCategories>
        <S.ListIntegrations>
          {items
            .filter(
              (item) =>
                (item.category?.includes(categorySelected) || categorySelected === '') &&
                item.url !== undefined
            )
            .map((item) => {
              return (
                <li
                  key={item.appName}
                  onClick={() => {
                    setAppSelected(item);
                  }}
                >
                  <img src={item.appLogo?.url} alt={item.appName} width={250} height={250} />
                  <h5>{item.appName}</h5>
                </li>
              );
            })}
          <S.Banners>
            {banners.map((item) => {
              return (
                <li key={item.title}>
                  <Link href={item.link}>
                    <a href={item.link} target="_blank" rel="noreferrer">
                      <img src={item.icon.url} alt={item.title} width={75} height={75} />
                      <strong>{item.title}</strong> <p>{item.description}</p>
                      <span>{item.label}</span>
                    </a>
                  </Link>
                </li>
              );
            })}
          </S.Banners>
        </S.ListIntegrations>
      </S.Integrations>
      {appSelected && (
        <>
          <S.Overlay onClick={() => setAppSelected(undefined)} />
          <Popup appSelected={appSelected} handleSetCategorySelected={handleSetCategorySelected} />
        </>
      )}
    </S.Container>
  );
};
